<template>
  <div>
    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap fill-height>
          <v-flex xs12 lg6 class="head_contain">
            <p class="table_card__head--title">
              Tipos de Invitación
            </p>
          </v-flex>
          <v-flex xs12 lg6 class="filter_options">
            <v-flex class="right">
              <button class="faccess_button" @click="modal_create = true">
                CREAR TIPO
              </button>
            </v-flex>
            <div class="buttom_reload" @click="getInvitedTypes()">
              <img src="@/assets/img/icons/refresh-icon.svg" />
            </div>
          </v-flex>
        </v-layout>
      </div>
      <div>
        <v-data-table
          v-model="invitedTypes"
          :headers="options_table.headers_table"
          :items="invitedTypes"
          :pagination.sync="options_table.pagination"
          select-all
        >
          <template slot="headers" slot-scope="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                  'column sortable',
                  options_table.pagination.descending ? 'desc' : 'asc',
                  header.value === options_table.pagination.sortBy
                    ? 'active'
                    : ''
                ]"
                @click="changeSort(header.value)"
              >
                <v-icon small>arrow_upward</v-icon>
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <tr>
              <td class="text-xs-center">{{ props.item.attributes.name }}</td>
              <td class="text-xs-center">
                <span v-for="department in filterDepartments(props.item.attributes.order_of_approval)"
                  >{{ department }}<br
                /></span>
                <!-- {{ filterDepartments(props.item.attributes.order_of_approval) }} -->
              </td>
              <td class="text-xs-center">
                <button @click="showModalInEditMode(props.item)">
                  Editar
                </button>
              </td>
              <!-- <td class="text-xs-center">
              <a @click.prevent="showConfirmModal(props.item.id)">
                Eliminar
              </a>
            </td> -->
            </tr>
          </template>
        </v-data-table>
      </div>

      <section v-if="show_confirm_modal" class="access_devices__modal">
        <section class="access_devices__modal--container" style="width: 40%;">
          <!-- <p class="access_devices__modal--text" style="text-align: justify;">
          <b>AVISO:</b> Al eliminar el plan de usuario se <b>denegará</b> el acceso de los usuarios a las locaciones incluidas en este plan y serán <b>desvinculados</b> de las locaciones a las que esten relacionados.
        </p>
        <br> -->
          <p class="access_devices__modal--text">
            ¿Está seguro de eliminar el tipo de invitación?
          </p>
          <div class="access_devices__modal--buttons" style="margin-top: 1rem;">
            <div
              class="access_devices__modal--button"
              @click="closeConfirmModal"
            >
              Cancelar
            </div>
            <div
              class="access_devices__modal--button active"
              @click="deleteUserCategory"
            >
              Si
            </div>
          </div>
        </section>
      </section>
    </div>
    <template>
      <!-- create type dialog -->
      <v-dialog v-model="modal_create" persistent max-width="424px">
        <v-card>
          <div class="invitation__new">
            <div class="invitation__new--title">
              <p class="invitation__new_text--title">
                {{
                  is_editing
                    ? "Editar tipo de invitación"
                    : "Crear tipo de invitación"
                }}
              </p>
            </div>
            <div class="invitation__new--info_container">
              <v-flex xs12>
                <v-text-field
                  label="Nombre"
                  v-model="new_type.invited_type_name"
                  v-validate="'required|alpha_spaces'"
                  name="name"
                ></v-text-field>
                <p
                  v-show="errors.has('name')"
                  class="invitation__new--error_message"
                >
                  Ingresa un nombre del tipo
                </p>
              </v-flex>

              <v-flex>
                <v-checkbox
                  v-model="show_approval_departments"
                  label="¿Necesita validación?"
                ></v-checkbox>
              </v-flex>

              <v-select
                v-if="show_approval_departments"
                v-model="new_type.order_of_approval"
                :items="approval_departments"
                item-text="attributes.name"
                item-value="id"
                label="Departamento aprobador"
                flat
                hide-details
                small
                multiple
                clearable
              >
              </v-select>

              <div class="invitation__new--actions">
                <p class="invitation__buttons--blue" @click="createType()">
                  ENVIAR
                </p>
                <p
                  class="invitation__buttons--gray"
                  @click="closeCreateModal()"
                >
                  CANCELAR
                </p>
              </div>
            </div>
          </div>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      available_locations: [],
      search: "",
      is_load: false,
      modal_create: false,
      is_editing: false,
      show_approval_departments: false,
      approval_departments: [],
      new_type: {
        user_id: this.getUserId(),
        invited_type_name: "",
        order_of_approval: []
      },
      options_table: {
        pagination: {
          sortBy: "name",
          rowsPerPage: 10
        },
        headers_table: [
          {
            text: "Nombre",
            align: "center",
            value: "name"
          },
          {
            text: "Orden de validación",
            align: "center",
            value: "order_of_approval"
          },
          {
            text: "Actualizar",
            align: "center",
            value: "update"
          }
          // {
          //   text: "Eliminar",
          //   align: "center",
          //   value: "delete"
          // }
        ],
        filters: {
          access_state: []
        }
      },
      invitedTypes: [],
      show_confirm_modal: false,
      user_category_to_delete: null,
      approval_departments: []
    };
  },
  mounted() {
    this.getInvitedTypes();
    this.getApprovalDepartments();
  },
  methods: {
    createType() {
      this.$validator.validateAll().then(result => {
        if (!result) return;
        const url = this.is_editing
          ? "invited_type/" + this.new_type.invited_type_id
          : "invited_type";
        const method = this.is_editing ? "put" : "post";
        const payload = {
          data: this.encrypt(this.new_type).toString()
        };
        const headers = {
          "X-Device-ID": this.getDeviceId(),
          Authorization: "Bearer " + this.getUserToken()
        };
        try {
          this.$http[method](url, payload, { headers }).then(
            function(response) {
              this.datePickerFirstClick2 = false;
              this.modal_create = false;
              this.updateAlertMessage(response.body.ans);
              this.updateIsInAlert(true);
              this.getApprovalDepartments();
              this.getInvitedTypes();
              this.clearNewInvitationTypeData();
              this.is_editing = false;
              if (
                response.body.meta != undefined &&
                response.body.meta != null
              ) {
                if (
                  response.body.meta.authentication_token != undefined &&
                  response.body.meta.authentication_token != null
                ) {
                  this.checkToken(response.body.meta.authentication_token);
                }
              }
            },
            function(response) {
              if (typeof response.body.errors[0].details != "object") {
                this.updateAlertMessage(response.body.errors[0].details);
                this.updateIsInAlert(true);
              } else {
                let message = [];
                for (var key in response.body.errors[0].details) {
                  message.push(response.body.errors[0].details[key]);
                }
                this.updateAlertMessage(message);
                this.updateIsInAlert(true);
              }
            }
          );
        } catch (e) {
          alert(e.message);
        }
      });
    },
    changeSort(column) {
      if (this.options_table.pagination.sortBy === column) {
        this.options_table.pagination.descending = !this.options_table
          .pagination.descending;
      } else {
        this.options_table.pagination.sortBy = column;
        this.options_table.pagination.descending = false;
      }
    },
    closeCreateModal() {
      this.modal_create = false;
      this.show_approval_departments = false;
      if (this.is_editing) {
        this.clearNewInvitationTypeData();
        this.is_editing = false;
      }
    },
    clearNewInvitationTypeData() {
      this.$validator.reset();
      this.show_approval_departments = false;
      this.new_type = {
        user_id: this.getUserId(),
        invited_type_name: "",
        order_of_approval: []
      };
    },
    filterDepartments(ids) {
      var approval_departments = [];
      for (var i = 0; i < ids.length; i++) {
        approval_departments.push(
          this.approval_departments.find(element => element.id == ids[i])
            .attributes.name
        );
      }
      return approval_departments;
    },
    showModalInEditMode(invitation) {
      this.modal_create = true;
      this.is_editing = true;
      
      const filteredInvitation = this.invitedTypes.find(invitedType => {
        return invitedType.id === invitation.id;
      });
      this.new_type.invited_type_name = filteredInvitation.attributes.name;
      this.new_type.invited_type_id = filteredInvitation.id;
      this.new_type.order_of_approval = filteredInvitation.attributes.order_of_approval.map(id => {
        return typeof id === "string" ? id: String(id)
      })
      if (this.new_type.order_of_approval.length)
        this.show_approval_departments = true;
    },
    locationsNames(arr) {
      let locations = this.available_locations.filter(loc => {
        return arr.includes(loc.location_id);
      });
      let locationStr = "";
      locations.map(loc => {
        locationStr += locationStr == "" ? loc.name : `, ${loc.name}`;
      });
      locationStr =
        locationStr != ""
          ? locationStr
          : "<b>EL PLAN NO POSEE ACCESO A NINGUNA SEDE</b>";
      return locationStr;
    },
    deleteUserCategory() {
      this.$http
        .delete("user_categories/destroy", {
          headers: {
            "X-Device-ID": this.getDeviceId(),
            Authorization: "Bearer " + this.getUserToken()
          },
          params: {
            data: {
              id: this.user_category_to_delete,
              company_id: this.getCompany().id
            }
          }
        })
        .then(function(response) {
          this.updateAlertMessage(
            "Plan de usuario eliminado satisfactoriamente"
          );
          this.updateIsInAlert(true);
          this.getUsersCategories();
        })
        .catch(function(response) {
          this.updateAlertMessage(response.body.errors[0].title);
          this.updateIsInAlert(true);
        });

      this.closeConfirmModal();
    },
    getApprovalDepartments() {
      try {
        this.$http
          .get("approval_department", {
            headers: {
              "X-Device-ID": this.getDeviceId(),
              Authorization: "Bearer " + this.getUserToken()
            },
            params: {
              data: {
                user_id: this.getUserId(),
                company_id: this.getCompany().id
              }
            }
          })
          .then(function(response) {
            this.approval_departments = response.body.data;
          });
      } catch (e) {
        alert(e);
      }
    },
    getInvitedTypes() {
      try {
        this.$http
          .get("invited_type", {
            headers: {
              "X-Device-ID": this.getDeviceId(),
              Authorization: "Bearer " + this.getUserToken()
            },
            params: {
              data: {
                user_id: this.getUserId()
              } 
            }
          })
          .then(function(response) {
            this.invitedTypes = response.body.data;
          });
      } catch (e) {
        alert(e.message);
        if (response.body.meta != undefined && response.body.meta != null) {
          if (
            response.body.meta.authentication_token != undefined &&
            response.body.meta.authentication_token != null
          ) {
            this.checkToken(response.body.meta.authentication_token);
          }
        }
      }
    },
    sortAvailableLocations(dataResponse) {
      this.available_locations = [];
      for (var i = 0; i < dataResponse.data.length; i++) {
        if (dataResponse.data[i].attributes.published == true) {
          this.available_locations.push({
            location_id: parseInt(dataResponse.data[i].id),
            name: dataResponse.data[i].attributes.name
          });
        }
      }
    },
    showConfirmModal(userCategoryId) {
      this.user_category_to_delete = userCategoryId;
      this.show_confirm_modal = true;
    },
    closeConfirmModal() {
      this.user_category_to_delete = null;
      this.show_confirm_modal = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/invitations/business_invitations/InvitationTypes.vue